export default {
  FIRST_ROUND_ID: 1,
  PENULTIMATE_ROUND_ID: 14,
  FINAL_ROUND_ID: 15,
};
